(function () {
  function initGallery(wrapper) {
    var list = wrapper.querySelector('.product__media-list');
    var slides = Array.prototype.slice.call(wrapper.querySelectorAll('.product__media-item'));
    if (!list || slides.length < 2) return;

    var prevBtn = wrapper.querySelector('.slider-buttons .slider-button--prev');
    var nextBtn = wrapper.querySelector('.slider-buttons .slider-button--next');
    if (!prevBtn || !nextBtn) return;

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function currentIndex() {
      var activeIdx = slides.findIndex(function (s) {
        return s.classList.contains('is-active');
      });
      if (isDesktop()) {
        return activeIdx === -1 ? 0 : activeIdx;
      }
      // On mobile all slides stay in normal flow (nothing is display:none),
      // so figure out "current" from actual scroll position instead.
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (s, i) {
        var dist = Math.abs(s.offsetLeft - list.scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function setThumbnail(target) {
      var targetId = target.getAttribute('data-media-id');
      if (!targetId) return;
      var thumbItem = document.querySelector('[data-target="' + targetId + '"]');
      if (!thumbItem) return;
      document.querySelectorAll('.thumbnail[aria-current="true"]').forEach(function (t) {
        t.removeAttribute('aria-current');
      });
      var thumbBtn = thumbItem.matches('button') ? thumbItem : thumbItem.querySelector('button');
      if (thumbBtn) thumbBtn.setAttribute('aria-current', 'true');
    }

    // Desktop-only movement. Mobile gave repeated, confirmed-on-device
    // trouble (stuck galleries, broken counters) every time this tried to
    // move the gallery with custom JS — scrollIntoView, scrollTo, raw
    // scrollLeft, all fighting this track's scroll-snap-type:x mandatory
    // and/or iOS's own elastic overscroll in ways that were never reliably
    // fixable from here. Mobile now gets zero custom scroll-position code:
    // swiping is the browser's own native scrolling (always worked), and
    // the prev/next buttons are left to Dawn's own native SliderComponent
    // click handler (already bound to these same buttons in global.js) —
    // tested, shipped code, not another custom attempt. Net effect: no
    // looping on mobile (stops at the first/last photo, like most product
    // galleries), but nothing left that can get stuck.
    //
    // isDesktop() is checked fresh on every click (not once at init) so a
    // width change after load — rotating a device, a tablet near the
    // breakpoint — doesn't lock the gallery into the wrong mode.
    function goTo(index) {
      var wrapped = (index + slides.length) % slides.length;
      var current = slides[currentIndex()];
      var target = slides[wrapped];
      if (current === target) return;
      current.classList.remove('is-active');
      target.classList.add('is-active');
      setThumbnail(target);
    }

    prevBtn.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      e.preventDefault();
      e.stopPropagation();
      goTo(currentIndex() - 1);
    });

    nextBtn.addEventListener('click', function (e) {
      if (!isDesktop()) return;
      e.preventDefault();
      e.stopPropagation();
      goTo(currentIndex() + 1);
    });
  }

  function initZoomGate(wrapper) {
    wrapper.querySelectorAll('.product__modal-opener').forEach(function (opener) {
      var toggle = opener.querySelector('.product__media-toggle');
      var icon = opener.querySelector('.product__media-icon');
      if (!toggle) return;

      // Dawn opens zoom on any single click/tap anywhere on the photo. That
      // meant a swipe stranded at the end of the gallery (nothing left to
      // scroll to) could register as a plain tap and pop zoom open by
      // accident. Require a more deliberate action instead: the zoom badge
      // itself, a double-click/double-tap, or Enter/Space for keyboard
      // users — swiping or single-clicking the photo never does.
      var freshToggle = toggle.cloneNode(true);
      toggle.parentNode.replaceChild(freshToggle, toggle);

      var modal = document.querySelector(opener.getAttribute('data-modal'));
      function openModal() {
        if (modal) modal.show(freshToggle);
      }

      freshToggle.addEventListener('dblclick', function (e) {
        e.preventDefault();
        openModal();
      });
      freshToggle.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          openModal();
        }
      });

      if (icon) {
        icon.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openModal();
        });
      }
    });
  }

  function init() {
    document.querySelectorAll('.product__media-wrapper').forEach(function (wrapper) {
      initGallery(wrapper);
      initZoomGate(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
